import React from "react";
import FeaturedOrderStage from "pages/OrdersView/OrderStatusPage/components/FeaturedOrderStage";

export default function OrderDashboardOrderStatus() {
  return <FeaturedOrderStage />;
}
